import React from "react";

export const Description = ({ description, helpers = {} }) =>
    description ? (
        <footer className="description">
            <helpers.widgets.smartText text={description} helpers={helpers} />
        </footer>
    ) : null;
